import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthService } from 'src/app/services/auth.service';
import { loadingAction } from '../../shared/state/actions/loading.action';
import { ApplicationStore } from '../../shared/state/store/index';

@Component({
	selector: 'app-not-authorized',
	templateUrl: './not-authorized.component.html',
	styleUrls: ['./not-authorized.component.scss']
})
export class NotAuthorizedComponent implements OnInit {
	constructor(private store: Store<ApplicationStore>, private authService: AuthService, private router: Router) { }

	ngOnInit(): void {
		this.store.dispatch(loadingAction({ loading: true }));
		this.authService.logout().subscribe(() => {
			this.store.dispatch(loadingAction({ loading: false }));
		});
	}
}
